import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import { useBreadcrumbs } from '../components/breadcrumbs/BreadcrumbContext';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@roger/ui-components';

const TestingX12_835: React.FC = () => {
  const navigate = useNavigate();
  useBreadcrumbs([{ label: 'X12 835' }]);

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Coming Soon</CardTitle>
          <CardDescription>
            X12 835 healthcare claim payment/advice testing is currently under
            development
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className='text-center py-12'>
            <div className='text-6xl mb-4'>💰</div>
            <h3 className='text-lg font-semibold mb-2'>X12 835 Testing</h3>
            <p className='text-muted-foreground mb-4'>
              This feature will allow you to test X12 835 healthcare claim
              payment/advice processing, including payment information parsing
              and remittance advice handling.
            </p>
            <Button onClick={() => navigate('/testing')}>
              Back to Testing Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TestingX12_835;
